import angular from "angular";

import { downgradeInjectable } from "@angular/upgrade/static";

import { IotManager } from "./iot-manager";
import { IotMessageManager } from "./iot-message-manager";
import { IotHistoryManager } from "./iot-history-manager";
import { IotMessageRecoveryManager } from "./iot-message-recovery-manager";
import { IotHistoryStorage } from "./iot-history-storage.service";
import { IotConnectionManager } from "./iot-connection-manager";

angular.module('core')
    .service('IotManager', IotManager)
    .service('IotConnectionManager', IotConnectionManager)
    .service('IotMessageManager', IotMessageManager)
    .service('IotHistoryManager', IotHistoryManager)
    .service('IotMessageRecoveryManager', IotMessageRecoveryManager)
    .service('IotHistoryStorage', downgradeInjectable(IotHistoryStorage))